import {PageAttachment, TempPageAttachment} from '~shared/models';

import {AttachmentsState} from './types';

export interface SetPageTempAttachmentsData {
    temporary: TempPageAttachment[];
    pageId: number;
}

const setAttachmentsDetails = (state: AttachmentsState, attachment: PageAttachment) => {
    state.entities[attachment.id] = Object.assign({}, state.entities[attachment.id], attachment);
};

const setPageTempAttachments = (state: AttachmentsState, data: SetPageTempAttachmentsData) => {
    const {temporary, pageId} = data;
    state.temporary[pageId] = temporary.concat(state.temporary[pageId] || []);
};

export interface RemoveTempAttachmentByIdData {
    attachmentId: number;
    pageId: number;
}
const removeTempAttachmentById = (state: AttachmentsState, data: RemoveTempAttachmentByIdData) => {
    const {pageId, attachmentId} = data;

    const entity = state.temporary[pageId];
    if (!entity) {
        return;
    }
    const index = (entity || []).findIndex((temp) => temp.id === attachmentId);
    if (index !== -1) {
        entity.splice(index, 1);
    }
};

export interface RemoveTempAttachmentData {
    temp: TempPageAttachment;
    pageId: number;
}

const removeTempAttachment = (state: AttachmentsState, data: RemoveTempAttachmentData) => {
    const {
        pageId,
        temp: {uid},
    } = data;

    const entity = state.temporary[pageId];

    if (!entity) {
        return;
    }

    const index = (entity || []).findIndex((temp) => temp.uid === uid);

    if (index !== -1) {
        entity.splice(index, 1);
    }
};

export {
    setAttachmentsDetails,
    setPageTempAttachments,
    removeTempAttachmentById,
    removeTempAttachment,
};
